// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__1xvEW","legacyBtn":"MutateMid_legacyBtn__2Q2QS"};